import { render, staticRenderFns } from "./StoragePanDianDan.vue?vue&type=template&id=3ad4a3ae&scoped=true&"
import script from "./StoragePanDianDan.vue?vue&type=script&lang=js&"
export * from "./StoragePanDianDan.vue?vue&type=script&lang=js&"
import style0 from "./StoragePanDianDan.vue?vue&type=style&index=0&id=3ad4a3ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4a3ae",
  null
  
)

export default component.exports